import { memo } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { SPOTS_LAYER_STYLE } from '../../../constants/map';
import { selectedSpotLayerState, spotsGeojsonState } from '../../../storage/map';

function SpotsLayer() {
  const selectedSpotLayer = useRecoilValue(selectedSpotLayerState);
  const spotsGeojson = useRecoilValue(spotsGeojsonState);

  if (!selectedSpotLayer || !spotsGeojson) return null;

  const geojson = spotsGeojson[selectedSpotLayer];

  if (!geojson) return null;

  return (
    <Source
      type="geojson"
      data={geojson}
      id="spots"
    >
      <Layer {...SPOTS_LAYER_STYLE} />
    </Source>
  );
}

export default memo(SpotsLayer);
